import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import TestimonialsHero from './components/TestimonialsHero';
import TestimonialGrid from './components/TestimonialGrid';
import VideoTestimonials from './components/VideoTestimonials';
import StatisticsBanner from './components/StatisticsBanner';

export default function Testimonials() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <TestimonialsHero />
      <TestimonialGrid />
      <VideoTestimonials />
      <StatisticsBanner />
      <Footer />
    </div>
  );
}